<template lang="pug">
  ev-dialog.ev-dialog(
    :value="true"
    v-bind="dialogProps"
    @click:outside="$modals.close()"
  )
    template(v-slot:dialog="{ close }")
      portal-target(
        :name="`${inputValue}.dialog`"
        :slot-props="{ close, attrs: $attrs }"
        slim
      )
    template(v-slot:content="{ close }")
      portal-target(
        :name="`${inputValue}.content`"
        :slot-props="{ close, attrs: $attrs }"
        slim
      )

    template(v-slot:actions="{ close }")
      portal-target(
        :name="`${inputValue}.actions`"
        :slot-props="{ close }"
        slim
      )
</template>

<script>
import EvDialog from '@/components/EvDialog.vue';

export default {
  components: {
    EvDialog,
  },
  props: {
    title: { type: String, default: null },
    inputValue: { type: String, required: true },
    dialogProps: {
      type: Object,
      default: () => ({
        width: 560,
      }),
    },
  },
};
</script>
